import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-144ca6fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-sider__inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dashboard-sider__decor",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "dashboard-sider__brand-mark"
}
const _hoisted_5 = {
  key: 1,
  class: "dashboard-sider__brand-text"
}
const _hoisted_6 = { class: "dashboard-sider__brand-title" }
const _hoisted_7 = { class: "dashboard-sider__brand-tagline" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dashboard-sider__divider" }, null, -1))
const _hoisted_9 = { class: "dashboard-sider__content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket dashboard-sider__back-icon" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "dashboard-sider__back-label"
}

import { ref, onMounted, onBeforeUnmount, watch, computed } from "vue";
import { apiView } from "@/api/index";
import { useRouter } from "vue-router";
import utils from "@/utils/Utils";
import commons from "@/utils/Common";
import DashboardMenuItem from "@/components/Sidebars/DashboardMenuItem.vue";

const LG_BREAKPOINT = 992;
const MINI_WIDTH = 72;

interface SlideMenuItem {
  id: number;
  parent: number;
  linkTo: string;
  linkLabel: string;
  icon?: string;
  children?: SlideMenuItem[];
}

interface Props {
  sidebarCollapsed: boolean;
  sidebarColor: string;
  sidebarTheme: string;
  backLabel?: string;
  backUrl?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSidebar',
  props: {
    sidebarCollapsed: { type: Boolean, default: false },
    sidebarColor: { default: "primary" },
    sidebarTheme: { default: "light" },
    backLabel: { default: "Quay lại Trang chủ" },
    backUrl: { default: "" }
  },
  emits: ["toggleSidebar"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const propsData = __props;

const sidebarColorVal = computed(() => propsData.sidebarColor ?? "primary");
const sidebarThemeVal = computed(() => propsData.sidebarTheme ?? "light");

const router = useRouter();
const menuList = ref<SlideMenuItem[]>([]);
const openKeys = ref<string[]>([]);
const selectedKeys = ref<string[]>([]);
const isMobile = ref(false);
const company = ref<Record<string, string>>({});

const activePath = computed(() => router.currentRoute.value.path);
const isMiniMode = computed(() => propsData.sidebarCollapsed && !isMobile.value);
const isHiddenMode = computed(() => propsData.sidebarCollapsed && isMobile.value);
const collapsedWidth = computed(() => (isMobile.value ? 0 : MINI_WIDTH));
const companyName = computed(
  () => company.value.sub_name || company.value.subName || "KIMAHOME"
);
const companyTagline = computed(
  () => company.value.summary || "LUXURY FURNITURE"
);
const companyLogo = computed(
  () => company.value.logo || company.value.urlLogo || ""
);
const companyInitial = computed(() => companyName.value.charAt(0).toUpperCase());

const menuItemKey = (item: SlideMenuItem) =>
  item.linkTo?.trim() ? item.linkTo : `menu-${item.id}`;

const updateViewport = () => {
  isMobile.value = window.innerWidth < LG_BREAKPOINT;
};

const normalizeFlatMenu = (res: any): SlideMenuItem[] => {
  const payload = res?.data?.data ?? res?.data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.body)) {
    return payload.body;
  }
  if (Array.isArray(res?.data?.body)) {
    return res.data.body;
  }
  const parsed = utils.parseJSON(payload);
  if (Array.isArray(parsed)) {
    return parsed;
  }
  if (Array.isArray(parsed?.body)) {
    return parsed.body;
  }
  return [];
};

const buildMenuTree = (flat: SlideMenuItem[]): SlideMenuItem[] => {
  const map = new Map<number, SlideMenuItem>();

  flat.forEach((item) => {
    map.set(item.id, { ...item, children: [] });
  });

  const roots: SlideMenuItem[] = [];

  flat.forEach((item) => {
    const node = map.get(item.id);
    if (!node) {
      return;
    }
    const parentId = Number(item.parent) || 0;
    if (parentId === 0) {
      roots.push(node);
      return;
    }
    const parent = map.get(parentId);
    if (parent?.children) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  });

  const trimEmptyChildren = (nodes: SlideMenuItem[]) => {
    nodes.sort((a, b) => a.id - b.id);
    nodes.forEach((node) => {
      if (node.children?.length) {
        trimEmptyChildren(node.children);
      } else {
        delete node.children;
      }
    });
  };

  trimEmptyChildren(roots);
  return roots;
};

const findOpenKeysForPath = (
  items: SlideMenuItem[],
  path: string,
  parents: string[] = []
): string[] | null => {
  for (const item of items) {
    if (item.linkTo === path) {
      return parents;
    }
    if (item.children?.length) {
      const found = findOpenKeysForPath(item.children, path, [
        ...parents,
        menuItemKey(item),
      ]);
      if (found !== null) {
        return found;
      }
    }
  }
  return null;
};

const syncMenuState = () => {
  const path = activePath.value;
  const matchKey =
    findMenuKeyByPath(menuList.value, path) ?? path;
  selectedKeys.value = [matchKey];

  const keys = findOpenKeysForPath(menuList.value, path);
  if (keys !== null) {
    openKeys.value = keys;
  }
};

const findMenuKeyByPath = (
  items: SlideMenuItem[],
  path: string
): string | null => {
  for (const item of items) {
    if (item.linkTo === path) {
      return menuItemKey(item);
    }
    if (item.children?.length) {
      const found = findMenuKeyByPath(item.children, path);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

const loadData = async () => {
  const res: any = await apiView("admin-slide-menu");
  const flat = normalizeFlatMenu(res);
  menuList.value = buildMenuTree(flat);
  syncMenuState();
};

const loadCompany = () => {
  const data = commons.getCokiesCompany();
  if (data) {
    company.value = data;
  }
};

const onMenuClick = (item: SlideMenuItem) => {
  if (item.linkTo?.trim()) {
    router.push(item.linkTo);
  }
};

const onCollapse = (collapsed: boolean) => {
  emit("toggleSidebar", collapsed);
};

const onBreakpoint = (broken: boolean) => {
  isMobile.value = broken;
  emit("toggleSidebar", broken);
};

const goHome = () => {
  router.push("/");
};

const onBack = () => {
  const url = propsData.backUrl?.trim();
  if (url) {
    window.location.href = url;
    return;
  }
  goHome();
};

onMounted(async () => {
  updateViewport();
  loadCompany();
  await loadData();
  window.addEventListener("resize", updateViewport);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateViewport);
});

watch(activePath, () => {
  syncMenuState();
});

watch(menuList, () => syncMenuState(), { deep: true });

watch(isMiniMode, (mini) => {
  if (mini) {
    openKeys.value = [];
  } else {
    syncMenuState();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    collapsible: "",
    class: _normalizeClass(["sider-primary dashboard-sider", [
      'ant-layout-sider-' + sidebarColorVal.value,
      'ant-layout-sider-' + sidebarThemeVal.value,
      {
        'dashboard-sider--collapsed': _ctx.sidebarCollapsed,
        'dashboard-sider--mini': isMiniMode.value,
        'dashboard-sider--hidden': isHiddenMode.value,
      },
    ]]),
    breakpoint: "lg",
    "collapsed-width": collapsedWidth.value,
    width: "256px",
    collapsed: _ctx.sidebarCollapsed,
    onCollapse: onCollapse,
    onBreakpoint: onBreakpoint,
    trigger: null,
    theme: "light",
    style: { backgroundColor: 'transparent' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "dashboard-sider__brand",
          onClick: goHome
        }, [
          (isMiniMode.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (companyLogo.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: companyLogo.value,
                      alt: companyName.value,
                      class: "dashboard-sider__brand-img"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(companyInitial.value), 1))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(companyName.value), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(companyTagline.value), 1)
              ]))
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_menu, {
            mode: "inline",
            class: "dashboard-sidebar-menu",
            openKeys: openKeys.value,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((openKeys).value = $event)),
            selectedKeys: selectedKeys.value,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
            "inline-collapsed": isMiniMode.value,
            "inline-indent": 16
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  (item.children?.length)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: menuItemKey(item)
                      }, {
                        title: _withCtx(() => [
                          _createVNode(DashboardMenuItem, {
                            item: item,
                            "icon-only": isMiniMode.value
                          }, null, 8, ["item", "icon-only"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: child.id
                            }, [
                              (child.children?.length)
                                ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: menuItemKey(child)
                                  }, {
                                    title: _withCtx(() => [
                                      _createVNode(DashboardMenuItem, {
                                        item: child,
                                        "show-icon": false
                                      }, null, 8, ["item"])
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (sub) => {
                                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                                          key: menuItemKey(sub),
                                          onClick: ($event: any) => (onMenuClick(sub))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DashboardMenuItem, {
                                              item: sub,
                                              "show-icon": false
                                            }, null, 8, ["item"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: menuItemKey(child),
                                    onClick: ($event: any) => (onMenuClick(child))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(DashboardMenuItem, {
                                        item: child,
                                        "show-icon": false
                                      }, null, 8, ["item"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: menuItemKey(item),
                        onClick: ($event: any) => (onMenuClick(item))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(DashboardMenuItem, {
                            item: item,
                            "icon-only": isMiniMode.value
                          }, null, 8, ["item", "icon-only"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["openKeys", "selectedKeys", "inline-collapsed"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "dashboard-sider__back",
          onClick: onBack
        }, [
          _hoisted_10,
          (!isMiniMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.backLabel), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["collapsed-width", "collapsed", "class"]))
}
}

})